import { UserRepository } from "../../repositories/UserRepository";

/**
 * Get Users Use Case
 * Fetches all users with pagination
 */
export class GetUsersUseCase {
  constructor(private repository: UserRepository) {}

  async execute(page: number = 1, limit: number = 50, search?: string) {
    return await this.repository.getUsers(page, limit, search);
  }
}

